import React from 'react';
import { Text } from 'components/typography/Text';
import { CheckMarkIcon } from 'assets/icons/CheckMarkIcon';
import { ShouldRender } from 'components/ShouldRender';
import { useIntl } from 'react-intl';
import { useModal } from 'store/modals';
import { useAccessManagement2NModal } from '../../../AccessManagement2NModalContext/useAccessManagement2NModal';
import { discardChanges } from '../../../../discardChanges';
import styles from './styles.module.scss';

export const Group = ({ group }) => {
  
  const intl = useIntl();
  const modal = useModal();
  const accessManagement2NModal = useAccessManagement2NModal();
  const onGroupClick = () => discardChanges('group', group, intl, accessManagement2NModal, modal);

  const formattedGroupName = group.Name.length > 60 ? `${group.Name.substring(0, 60)}...` : group.Name;
  return (
    <div
      className={styles.groupCard}
      onClick={onGroupClick}
    >
      <div className={styles.details}>
        {/*<div className={styles.icon}>*/}
        {/*  {group.icon}*/}
        {/*</div>*/}
        <Text
          size={14}
          uppercase
        >
          {formattedGroupName}
        </Text>
      </div>

      <ShouldRender condition={accessManagement2NModal.selected.group && accessManagement2NModal.selected.group.Id === group.Id}>
        <CheckMarkIcon
          active
        />
      </ShouldRender>
    </div>
  );
};
